import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../../../../services/endpoints/endpoints.service";
import { PatientTag } from "../../../../models/endpoints/tags-endpoint.model";

export const useTags = () => {
	const queryClient = useQueryClient();
	const queryKey = ["tags"];

	const query = useQuery({
		queryKey: queryKey,
		queryFn: async (): Promise<PatientTag[]> => {
			const response = await EndpointsService.dataRetriever.getTags();
			return response;
		},
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
